import React, { useEffect, useState } from "react";
import { CTA02, DynamicNavigation, Footer, ServicePageSection } from "./components";
import {
  migrationServices,
  migrationServicesHeading,
  migrationServicesSubheading,
} from "./data/migrationServices";
import { useSeo } from "./seo";
import { swapJpegJpg, toRootAssetUrl } from "./utils/assetUrl";
import { useNavLinkClick } from "./hooks/useNavLinkClick";
import { Link } from "react-router-dom";

export default function ServicesPage() {
  useSeo({
    title: "Services | Hola World Migration",
    description:
      "Explore Australia migration services including skilled visas, employer-sponsored visas, family pathways, and visitor visas.",
    path: "/services",
    // image property removed to force global OG image
    breadcrumbs: [
      { name: "Home", url: "/" },
      { name: "Services", url: "/services" },
    ],
  });

  const desktopHeroBanner = "/assets/services-hero/services-hero-desktop.jpg";
  const mobileHeroBanner = "/assets/services-hero/mobile/services-hero-mobile.jpg";

  const [bannerLoaded, setBannerLoaded] = useState(false);


  // Preload logic removed to suppress browser warning and spinner.

  // Removed unnecessary useEffect

  const links = [
    { id: "home", label: "Home", href: "/" },
    { id: "services", label: "Services", href: "/services" },
    { id: "about", label: "About", href: "/about" },
    { id: "contact", label: "Contact", href: "/contact" },
  ];

  const onLinkClick = useNavLinkClick(links);

  // Removed unnecessary useEffect

  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <header className="w-full">
        <DynamicNavigation
          links={links}
          logo={<img src="/logo.png" alt="Logo" className="h-10 w-auto" />}
          showLabelsOnMobile={true}
          glowIntensity={6}
          onLinkClick={onLinkClick}
        />
      </header>

      <section id="hero" className="relative w-full">
        {/* Desktop Hero Banner */}
        <div className="hidden md:block w-full hero">
          <img
            src="/assets/services-hero/services-hero-desktop.jpg"
            alt="Test Banner"
            className="hero-img block select-none"
            loading="eager"
            decoding="async"
            draggable={false}
          />
          {/* Overlay Content */}
          <div className="absolute inset-0 z-10 flex items-center justify-center px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col items-start justify-center w-full max-w-6xl mx-auto">
              <h1 className="text-4xl md:text-6xl font-black text-white mb-4 drop-shadow-lg leading-tight">
                Your Australian Dream<br />
                Starts Here
              </h1>
            </div>
          </div>
        </div>
          <style>{`.hero { border-bottom: 4px solid #fff !important; }`}</style>
        {/* Mobile Hero Banner */}
        <div className="block md:hidden w-full hero">
          <img
            src="/assets/services-hero/mobile/services-hero-mobile.jpg"
            alt="Australia migration services"
            className="hero-img block select-none"
            loading="eager"
            decoding="async"
            draggable={false}
          />
          {/* Overlay Content */}
          <div className="absolute inset-0 z-10 flex items-center justify-center px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col items-center w-full max-w-2xl mx-auto">
              <h1 className="text-3xl font-black text-white mb-4 drop-shadow-lg">Australia Migration Services</h1>
            </div>
          </div>
        </div>
      </section>

      <main className="pb-16 bg-white">
        {/* Section 1: Two-column intro below hero, desktop/laptop only */}
        {/* Breadcrumb moved up, just below hero, above Section 1 */}
        <div className="hidden md:block w-full bg-white">
          <div className="mx-auto max-w-[1180px] pl-10 pr-6" style={{paddingTop: '24px', paddingBottom: 0}}>
            <nav aria-label="Breadcrumb" className="mb-2">
              <ol className="flex flex-wrap items-center gap-2 text-sm text-slate-500">
                <li><Link to="/" className="hover:text-slate-700 transition-colors duration-200">Home</Link><span aria-hidden="true">/</span></li>
                <li><span className="text-indigo-600 font-medium" aria-current="page">Services</span></li>
              </ol>
            </nav>
          </div>
        </div>
        {/* Section 1: About migration support Australia, no border, no breadcrumb, aligned content */}
        <section className="hidden md:block bg-white w-full">
          <div className="mx-auto max-w-[1180px] pl-10 pr-6 py-14 flex flex-row items-center gap-12">
            <div className="flex-1 min-w-[260px] max-w-[340px] flex flex-col justify-center">
              <h2 className="text-[32px] font-extrabold text-[#111] leading-tight tracking-tight text-left mb-4">About migration support Australia</h2>
            </div>
            <div className="flex-1 max-w-[540px] flex flex-col justify-center">
              <p className="text-lg text-slate-700 leading-relaxed mb-0">
                Hola World Migration Australia provides professional, reliable migration support for individuals and families seeking a future in Australia. Our services cover skilled, employer-sponsored, and family visa pathways, ensuring clarity and confidence at every step.
              </p>
            </div>
          </div>
        </section>
        {/* Section 1: Mobile fallback (unchanged) */}
        <section className="md:hidden bg-white w-full">
          <div className="mx-auto max-w-2xl px-4 py-8">
            <h2 className="text-2xl font-extrabold text-[#111] leading-tight tracking-tight text-left mb-2">About migration support Australia</h2>
            <p className="text-base text-slate-700 leading-relaxed mb-0">
              Hola World Migration Australia provides professional, reliable migration support for individuals and families seeking a future in Australia. Our services cover skilled, employer-sponsored, and family visa pathways, ensuring clarity and confidence at every step.
            </p>
          </div>
        </section>
        {/* ServicePageSection and CTA02 remain unchanged */}
        <div className="bg-white">
          <ServicePageSection services={migrationServices} />
          <CTA02 />
        </div>
      </main>

      <Footer />
    </div>
  );
}
